import { render, staticRenderFns } from "./Collocations.vue?vue&type=template&id=6bb5095c&scoped=true&"
import script from "./Collocations.vue?vue&type=script&lang=js&"
export * from "./Collocations.vue?vue&type=script&lang=js&"
import style0 from "./Collocations.vue?vue&type=style&index=0&id=6bb5095c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb5095c",
  null
  
)

component.options.__file = "Collocations.vue"
export default component.exports